"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class StaticBackend {
  constructor(services, options) {
    this.type = StaticBackend.type;
    this.init(services, options);
  }
  init(services, options = {}, i18nextOptions) {
    this.services = services;
    this.options = options;
    this.i18nextOptions = i18nextOptions;
  }
  read(language, namespace, callback) {
    let translations = this.i18nextOptions?.staticResources;
    if (Array.isArray(translations)) {
      translations = translations.reduce((prev, curr) => {
        return (0, _deepmerge.default)(curr, prev);
      }, {});
    }
    callback(null, translations?.[language]?.[namespace] || {});
  }
}
exports.default = StaticBackend;
StaticBackend.type = 'backend';